import type { BaseWeblogInstance } from '@/types/index';

export abstract class BasePlugin {
    declare weblog: BaseWeblogInstance;
    abstract destroy(): void;
    apply(weblog: BaseWeblogInstance) {
        this.weblog = weblog;
    }
    /**
     * 统一由 weblog 在页面关闭前调用的生命周期函数
     */
    beforeUnload?: (event: Event) => void;
    static key: string;
}

export interface BasePluginConstructor {
    new(options?: any): any;
    new(weblogger?: any, options?: any): any;
    key: string;
}
/**
 * 在 bootstrap 环境下自动注册插件
 * @param Plugin
 * @param optionKey
 */
export const autoRegister = (Plugin: any, optionKey?: string) => {
    if (
        typeof window === 'undefined' ||
        typeof window._GLOBAL_KS_WEBLOGGER_ === 'undefined' ||
        typeof Plugin !== 'function') return;
    const { weblog, config } = window._GLOBAL_KS_WEBLOGGER_;
    let option = optionKey ? config.plugins[optionKey]?.options : undefined;
    weblog.addPluginInstance(new Plugin(option));
}
